export default "__VITE_ASSET__PjdQMNBZ__"